import {useMutation} from '@tanstack/react-query';

import {apiClient} from '../../../../utils/api-client';

import {useRecentDocsQueryCache} from './use-recent-docs-query';

function addToRecentRequest(accession: string) {
    return apiClient.post({
        path: `editor-documents-service/api/user/documents/${accession}/recent`
    });
}

export function useAddToRecentDocsMutation() {
    const recentQueryCache = useRecentDocsQueryCache();

    return useMutation({
        mutationFn: (document: EditModeDoc) => {
            recentQueryCache.addDocument(document);

            return addToRecentRequest(document.accession);
        },
        onError: () => {
            recentQueryCache.invalidate();
        }
    });
}
